import { useTranslation } from 'react-i18next';
import { Box, Typography, useTheme } from '@mui/material';
import { CheckRounded } from '@mui/icons-material';


export const FormSent = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      height="100%"
      gap={4}
    >
      <CheckRounded color="success" sx={{ fontSize: theme.typography.h1.fontSize }} />
      
      <Typography variant='h4'>
        { t('supportForms.send.success') }
      </Typography>

      <Typography variant='subtitle1'>
        { t('supportForms.send.successMessage') }
      </Typography>
    </Box>
  );};
